import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { ObjUtils } from '@/common/utils/ObjUtils';
import { useCallback } from 'react';

export const UserList = ({ roleObj: role, groupObj: group }) => {

  const augRowsReq = useCallback((rowsReq) => {
    if (!role && !group) return;


    if (role) {
      rowsReq.query = 'ROLE_USER_DETAIL';
      rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams('roleId', role.id));
    }

    if (group) {
      rowsReq.query = 'GROUP_USER_DETAIL';
      rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams('groupId', group.id));
    }

  }, [role, group])


  return (
    <EntityList
      entity="USER"
      augRowsReq={augRowsReq}
      augTabButtons={(buttons) => { ObjUtils.clearObj(buttons) }}
    />
  )
}